import { render, staticRenderFns } from "./MainLearningContentTableActions.vue?vue&type=template&id=898c815a&"
import script from "./MainLearningContentTableActions.vue?vue&type=script&lang=js&"
export * from "./MainLearningContentTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports